module.exports = require('../lib/react')



//////////////////
// WEBPACK FOOTER
// ./~/emotion/react/index.js
// module id = 40
// module chunks = 0